const shareSelection = require('od-modules/helpers/share_selection');
const searchDynpack = require('od-modules/handlers/dynpack_search');
const trackingUtils = require('od-modules/utils/tracking.utils');
const tagManagement = require('od-modules/utils/tag_management.utils');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const currentSearchSingletonModel = require('od-modules/models/current_search.singleton.model');
const handlerWaitingPage = require('od-modules/handlers/dpresults/waiting_page');
const Dynpack = require('od-apps/app.dynpack');
const navigationImport = import('od-modules/handlers/dpresults/navigation');
const {
    getShoppingCartDeeplink,
    getShoppingCartErrors,
    confirmShoppingCart,
} = require('components/package_selection_info/dynpack_shopping_cart/api').default;

let page;
let $pageContainer;
let $section;
let $logo;
let hasScrollTop = true;
let allowTrackingToBeSent = true;
let $mainContainer;
let hasUserInteraction;
let widgets = {};
const $window = $(window);

const getAdvertisementElements = (product) => ({
    hotels: {
        adListGptSelector: '#dpAccModsky1 , #dpAccModsky2',
        adTravelAudience: [],
        adFixedBanner: '#dpAccModsky2',
        getAdvertisementList: () => [],
    },
    flights: {
        adListGptSelector: '#dpFlightModsky1 , #dpFlightModsky2',
        adTravelAudience: [],
        adFixedBanner: '#dpFlightModsky2',
        getAdvertisementList: () => [],
    },
}[product]);

const fixLateralSecondAdBannerDp = (idFixedBanner) => {
    const $adContainer = $section.find(idFixedBanner).parent();
    const $secondAdBanner = $section.find(idFixedBanner);
    if ($secondAdBanner.length > 0) {
        const firstAdHeight = $secondAdBanner.prev().height();
        const adTopContainerOffset = $adContainer.offset().top;
        const firstAdBottomOffset = firstAdHeight + adTopContainerOffset;
        const adContainerBottomOffset = $adContainer.height() + adTopContainerOffset;

        const isFixedOnBottom = adContainerBottomOffset > $window.scrollTop() + $secondAdBanner.height();
        const isFixedOnScroll = $window.scrollTop() > firstAdBottomOffset && !isFixedOnBottom;

        $secondAdBanner.toggleClass('fixed', isFixedOnScroll);
        $secondAdBanner.toggleClass('absolute', isFixedOnBottom);
    }
};

module.exports.commonDpResultsEventController = {
    globalEvents: {
        'global:loginOk': 'setLoggedUser',
    },
    viewEvents: {
        'share-selection-dp:onUpdateShareSelection': 'resetShareSelection',
        'dialog:launchNoResults': 'onDialogLaunchNoResults',
        'dp-automatic-refresh:refreshSearchResults': 'onRefreshSearchResults',
        'accommodation-details:open': 'onDetailsOpen',
        'dpwaiting-page:cleanDpWaitingPage': 'cleaningDpWaitingPage',
        'dpwaiting-page:hidePageOverDpWaitingPage': 'hiddenPageOverDpWaitingPage',
    },
    eventHandlers: {
        setLoggedUser() {
            widgets.getUsersManager().get('getUserDTO').then((user) => {
                shareSelection.setPassengerParameters(user);
            });
        },
        resetShareSelection() {
            widgets.shareSelection().execute('reset', shareSelection.getEmailParameters());
        },

        onDialogLaunchNoResults() {
            trackingUtils.trackEvent('results_list_dynpack', 'undo_searching_dynpack_no_results_found_NA',
                Odigeo.History.getPageNameFromFragment());
        },

        onRefreshSearchResults(data) {
            widgets.dpAutomaticRefresh().execute('preRefreshResults');
            Odigeo.Session.set('dpForceNewSearch', 'true');
            this.onDpSearchCompletedSuccessfully(data);
            widgets.dpAutomaticRefresh().execute('postRefreshResults');
        },

        endResultsLoading() {
            if ($pageContainer.hasClass('refreshing-results')) {
                this.scrollToResults();
                $pageContainer.removeClass('refreshing-results');
            }
            this.deactivateWaitingPage();
        },

        onDpToggleAccommodationDetails(settings) {
            widgets.accommodationDetails().execute('process', settings);
        },

        closeAccommodationDetails() {
            widgets.accommodationDetails().execute('closeDetails');
        },

        onDetailsOpen(options, top) {
            if (options.center) {
                setTimeout(() => this.onScrollTo({top}), 200);
            }
        },

        cleaningDpWaitingPage() {
            $mainContainer.removeClass('od-process-dpwaiting');
            $logo.removeClass('disabled');

            if (hasScrollTop) {
                $('html, body').scrollTop(0);
                hasScrollTop = false;
            }
        },

        hiddenPageOverDpWaitingPage() {
            $mainContainer.addClass('od-process-dpwaiting');
            $logo.addClass('disabled');
        },

        scrollToResults() {
            if (hasUserInteraction) {
                const position = $section.find('.products_container').offset();
                this.onScrollTo(position);
            }
        },

        onScrollTo(position = {top: 0}) {
            const duration = $.fx.muted ? 0 : 'fast';

            $section.attr('data-scrolling', true);

            return $('html, body').clearQueue().animate({
                scrollTop: position.top,
            }, duration, 'swing').promise().then(() => {
                $section.removeAttr('data-scrolling');
            });
        },

        activeAdv(product) {
            const {
                adListGptSelector,
                adTravelAudience,
                adFixedBanner,
                getAdvertisementList,
            } = getAdvertisementElements(product);
            this.dynpackAdvertisementLoadData(adListGptSelector, adTravelAudience);
            Odigeo.UIElements.enhanceAdvertisementAdSense(getAdvertisementList(), product);

            $window.off('scroll.fixedBanner');
            $window.on('scroll.fixedBanner', Odigeo._.bind(fixLateralSecondAdBannerDp, this, adFixedBanner));
        },

        trackingVirtualPage(page) {
            if (allowTrackingToBeSent) {
                trackingUtils.trackPage(page);
                tagManagement.updateDatalayer();
                allowTrackingToBeSent = false;
            }
        },
    },
};

module.exports.commonDpResultsUtils = {
    navigateHome() {
        Odigeo.trigger('dpsearch-manager:navigateHome');
    },

    navigateWithoutShoppingCart(route, params = '') {
        const deeplink = Odigeo._.last(Odigeo.History.getFragment().split('/'));

        navigationImport.then(({default: navigation}) => {
            navigation.navigate(route, deeplink.concat(params));
        });
    },

    navigate(route, params = '', bookingId) {
        this.getShoppingCartDeeplink().then((deeplink) => {
            navigationImport.then(({default: navigation}) => {
                navigation.navigate(route, deeplink.concat(params), bookingId);
            });
        });
    },

    nextPage(params = '') {
        this.getShoppingCartDeeplink().then((deeplink) => {
            navigationImport.then(({default: navigation}) => {
                navigation.next(Odigeo.History.getPageNameFromFragment(), deeplink.concat(params));
            });
        });
    },

    getShoppingCartDeeplink() {
        return getShoppingCartDeeplink()
            .then((deeplink) => {
                Odigeo.Session.set('dynpackDeeplink', deeplink);
                return deeplink;
            });
    },

    relaunchSearch(searchParams) {
        currentSearchSingletonModel.getInstance().set(searchParams);
        Odigeo.Router.navigate(page, {
            replace: true,
            params: Dynpack.searchParamsStringify(searchParams),
        });
    },

    onErrorGetSearchData() {
        const lastSearch = Odigeo.Utils.parseJson(Odigeo.Storage.get('lastSearchDynpack'));

        if (Odigeo._.isEmpty(lastSearch)) {
            this.navigateHome();
        } else {
            this.relaunchSearch(lastSearch);
        }
    },

    launchSearch(params, lastSearch) {
        if (!Odigeo._.isEmpty(params)) {
            searchDynpack.launchSearch(params, page, this.onErrorGetSearchData.bind(this));
        } else {
            Dynpack.getSearchData(params, page).then(function(searchParams) {
                this.relaunchSearch(lastSearch || searchParams);
            });
        }
    },

    launchSearchAndConfirm(params, page) {
        searchDynpack.launchSearch(params, page, this.navigateHome.bind(this), 'searchAndConfirm');
    },

    start(pageName, params) {
        page = pageName;
        const pageSelector = `#${page}`;
        const $page = $('#page');
        const lastSearch = Odigeo.Utils.parseJson(Odigeo.Storage.get('lastSearchDynpack'));

        hasScrollTop = true;
        allowTrackingToBeSent = true;
        $logo = $page.find('#logo');
        $section = $(pageSelector);
        $pageContainer = $section.find('.dpresults_page');
        $mainContainer = $page.find('.home_main_layout');
        hasUserInteraction = false;
        $section.one(Odigeo.Events.tap, () => hasUserInteraction = true);
        Odigeo.Session.set('page', page);
        Odigeo.UIElements.hideAllDialogs();
        $mainContainer.addClass('od-process-dpwaiting');
        this.launchSearch(params, lastSearch);
        trackingUtils.bindEvents($section);
        handlerWaitingPage.bindVisibility();
    },

    startWidgets(widgetsFromHandler) {
        widgets = Odigeo._.merge({}, widgetsFromHandler);
    },

    confirmAndContinue() {
        trackingUtils.startMetric('DYNPACK_PAX_PAGE_TRANSITION_TIME');
        return confirmShoppingCart()
            .then((shoppingCart = {}) => {
                trackingUtils.stopMetric('DYNPACK_PAX_PAGE_TRANSITION_TIME');
                widgets.dpAutomaticRefresh().execute('cleanScheduleExecution');
                this.navigate('details', ';redirect=dpresults', shoppingCart.bookingId);
            });
    },

    getWidgets: () => widgets,

    async checkErrors() {
        const errors = await getShoppingCartErrors();
        this.toggleAvailabilityError(errors);
    },

    async toggleAvailabilityError(errors) {
        const {default: factory} = await import('components/package_selection_info/error_message/js/main');
        const page = Odigeo.History.getPageNameFromFragment();
        const widgetLoader = createWidgetLoader({
            errorMessage: [`error-message-${Odigeo._.kebabCase(page)}`, factory],
        });

        widgetLoader.get('errorMessage').execute('hide');

        if (!Odigeo._.isEmpty(errors)) {
            widgetLoader.get('errorMessage').execute('show', errors);
        }
    },
};
